export const profile = {
  name: 'Putha Sri Hari Reddy',
  shortName: 'Sri Hari Reddy',
  aliases: ['Putha Sri Hari Reddy', 'Sri Hari Reddy', 'P Sri Hari Reddy', 'sri hari', 'srihari reddy', 'p srihari reddy', 'putha sri hari'],
  role: 'Founder & product engineer',
  company: 'PSHR INNOVEX Pvt. Ltd.',
  companyUrl: 'https://pshrinnovex.com/',
  location: 'Andhra Pradesh, India',
  email: 'psriharireddy@pshrinnovex.com',
  phone: '+91 63613 39623',
  phoneHref: 'tel:+916361339623',
  intro:
    'I help turn ambitious ideas into clear, useful digital products — combining product direction, considered interface design, and practical engineering.',
  social: {
    linkedin: 'https://www.linkedin.com/in/putha-sri-hari-reddy-901652326/',
    github: 'https://github.com/sriharired',
    instagram: 'https://www.instagram.com/__sriharireddy__/',
  },
  resume:
    'https://drive.google.com/file/d/16UL3ksoaNqmTTA3195T3IqghlMa5M3Z4/view?usp=sharing',
  images: {
    hero: {
      src: '/images/hari-night-640.webp',
      srcSet: '/images/hari-night-360.webp 360w, /images/hari-night-480.webp 480w, /images/hari-night-640.webp 640w',
      sizes: '(max-width: 760px) min(80vw, 360px), 430px',
      fallback: '/ig-3.JPG',
      alt: 'Putha Sri Hari Reddy in a night city setting',
    },
    gallery: [
      {
        src: '/images/hari-white.webp',
        fallback: '/ig-2.JPG',
        alt: 'Portrait of Putha Sri Hari Reddy in a white shirt',
        caption: 'Product thinker. Builder. Founder.',
      },
      {
        src: '/images/hari-maroon.webp',
        fallback: '/ig-1.JPG',
        alt: 'Portrait of Putha Sri Hari Reddy outdoors',
        caption: 'Curiosity is part of the process.',
      },
      {
        src: '/images/hari-studio.webp',
        fallback: '/profilepic.jpg',
        alt: 'Portrait of Putha Sri Hari Reddy',
        caption: 'Careful work, from first brief to release.',
      },
    ],
  },
};

export const company = {
  name: 'PSHR INNOVEX',
  legalName: 'PSHR INNOVEX Pvt. Ltd.',
  aliases: ['PSHR', 'pshrinnovex', 'pshr innovex'],
  statement: 'Modern software products, built with clarity.',
  description:
    'A founder-led product engineering company for teams shaping AI, SaaS, web, and mobile experiences.',
  services: [
    {
      number: '01',
      title: 'AI products',
      description: 'Assistants, AI workflows, and product intelligence designed around real tasks.',
      tags: ['Copilots', 'Knowledge tools', 'AI flows'],
    },
    {
      number: '02',
      title: 'SaaS & web platforms',
      description: 'Dashboards, portals, and product systems with a clearer structure and release readiness.',
      tags: ['Dashboards', 'Portals', 'Admin systems'],
    },
    {
      number: '03',
      title: 'Mobile apps',
      description: 'Cross-platform mobile experiences with polished hierarchy and a cleaner product flow.',
      tags: ['iOS + Android', 'Consumer UX', 'Launch-ready'],
    },
    {
      number: '04',
      title: 'UX & modernization',
      description: 'Redesign and refinement for products that need a more confident next version.',
      tags: ['UX systems', 'Product refresh', 'Conversion paths'],
    },
  ],
  principles: [
    'Product direction stays close to delivery decisions.',
    'Scope and release trade-offs are handled directly.',
    'Communication stays clear across time zones and milestones.',
  ],
  process: [
    { step: 'Discover', detail: 'Clarify the user, product stage, and the decision that matters next.' },
    { step: 'Design', detail: 'Shape hierarchy, interaction, and the system before visual noise appears.' },
    { step: 'Build', detail: 'Turn the product path into a resilient, maintainable experience.' },
    { step: 'Launch', detail: 'Close the loop with release readiness, hand-off, and the next iteration.' },
  ],
};

export const capabilities = [
  {
    title: 'Product direction',
    description: 'Connect business context, user flow, interface quality, and technical decisions into one clear path.',
    signal: '01',
  },
  {
    title: 'Experience systems',
    description: 'Build interfaces that make complex actions feel composed, responsive, and easy to trust.',
    signal: '02',
  },
  {
    title: 'Full-stack delivery',
    description: 'Bring the frontend, data flow, authentication, integrations, and release work into one accountable build.',
    signal: '03',
  },
  {
    title: 'AI workflows',
    description: 'Apply practical AI where it helps people move through a real task with more confidence.',
    signal: '04',
  },
];

export const workingAreas = [
  'AI workflows',
  'SaaS platforms',
  'Mobile product UX',
  'Web applications',
  'Product redesign',
  'Automation systems',
];

export const projects = [
  {
    id: 'vyapaar-mate',
    number: '01',
    category: 'SaaS product · Live platform',
    title: 'Vyapaar Mate',
    description:
      'A local commerce and CRM platform for Indian businesses, connecting web catalog checkouts with WhatsApp updates, UPI QR payment tracking, and an operational owner dashboard.',
    focus: ['SaaS', 'Product engineering', 'UX systems'],
    href: 'https://vyapaarmate.com/',
    hrefLabel: 'Visit live platform',
    accent: 'lime',
    detail:
      'The product connects customer-facing catalog and checkout journeys with owner-side operating workflows, so local commerce activity is easier to follow in one place.',
  },
  {
    id: 'budmeet',
    number: '02',
    category: 'Mobile-first product · Live product',
    title: 'BudMeet',
    description:
      'A mobile-first social discovery product focused on discovery, messaging, and interaction-driven product clarity.',
    focus: ['Mobile product', 'Interaction UX', 'Realtime flows'],
    href: 'https://budmeet.app/',
    hrefLabel: 'Visit product',
    accent: 'violet',
    detail:
      'BudMeet is shaped around the moments where product flow matters most: discovery, conversation, and the feedback that makes a social product feel immediate.',
  },
  {
    id: 'divine-tattoo',
    number: '03',
    category: 'Service-business web presence · Live website',
    title: 'Divine Tattoo Studio',
    description:
      'A polished studio website designed for portfolio trust, consultation intent, and clearer service discovery for tattoo clients.',
    focus: ['Brand website', 'Conversion UX', 'Service discovery'],
    href: 'https://effervescent-pie-6c7714.netlify.app/',
    hrefLabel: 'Visit website',
    accent: 'orange',
    detail:
      'The site is designed to make visual proof, service choice, and the next consultation step easy to understand without overwhelming prospective clients.',
  },
  {
    id: 'aether-cv',
    number: '04',
    category: 'Career product · Live product',
    title: 'Aether CV',
    description:
      'A resume-builder product focused on clearer, ATS-friendly resume creation with guided sections, polished templates, and export-ready profiles.',
    focus: ['Guided UX', 'Career tech', 'Product design'],
    href: 'https://aethercv.com/',
    hrefLabel: 'Visit Aether CV',
    accent: 'blue',
    detail:
      'Aether CV is built around a high-stakes user moment: helping candidates present their experience more clearly and move from draft to ready-to-share output.',
  },
];

export const faqs = [
  {
    question: 'Who is Putha Sri Hari Reddy?',
    answer:
      'Putha Sri Hari Reddy, also known as Sri Hari Reddy or P Sri Hari Reddy, is the founder of PSHR INNOVEX and a product engineer focused on AI, SaaS, web, and mobile experiences.',
  },
  {
    question: 'What does PSHR INNOVEX build?',
    answer:
      'PSHR INNOVEX helps teams shape and ship AI products, SaaS and web platforms, mobile applications, and UX modernization work.',
  },
  {
    question: 'How can I contact Sri Hari Reddy?',
    answer:
      'For direct product, partnership, or collaboration conversations, email psriharireddy@pshrinnovex.com or call +91 63613 39623.',
  },
];
